module.exports = __webpack_public_path__ + "bf.5e9823788c5b1c25d79b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bf.svg
// module chunks = styles